import { useTranslation } from "react-i18next"

import Dialog from "@/components/dialog/Dialog"
import BasicButton from "@/components/button/BasicButton"

interface Props {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  isDeleting: boolean
}

export default function DeleteConfirmDialog({ open, onConfirm, onCancel, isDeleting }: Props) {
  const { t } = useTranslation()

  return (
    <Dialog
      title={t("confirm")}
      open={open}
      onClose={onCancel}
      maxWidth="400px"
      footer={
        <>
          <BasicButton type="default-outlined" size="md" onClick={onCancel} disabled={isDeleting}>
            {t("button.cancel")}
          </BasicButton>
          <BasicButton
            type="danger-outlined"
            size="md"
            onClick={onConfirm}
            disabled={isDeleting}
            isLoading={isDeleting}>
            {t("button.delete")}
          </BasicButton>
        </>
      }>
      <p>{t("messages.confirmDelete")}</p>
    </Dialog>
  )
}
